import moment from "moment-jalaali";
import { useIndexedDB } from 'react-indexed-db-hook';
import Cookies from 'js-cookie';
import * as DOMPurify from 'dompurify';
import React from 'react';

export const validURL = (str) => {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
}


export const makeid = (length) => {
  var result = '';
  var characters = '0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}
export const checkForNumericEnFaString = (str) => {
  var res = true;
  const numberRegex = /[۰۱۲۳۴۵۶۷۸۹0-9]/
  if (str !== undefined) {
    var temp = str.split('')
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      numberRegex.test(element)
      if (!numberRegex.test(element)) {
        res = false
      }
    }

  } else {
    res = false

  }
  return res;
}
export const isValidURL = (string) => {
  var res = string.match(/(http(s):\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  return (res !== null)
};

export const isValidHttpUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}




export const farsi_number = (input) => {
  var persianDigits = "۰۱۲۳۴۵۶۷۸۹";
  var persianMap = persianDigits.split("");


  return input.replace(/\d/g, function (m) {
    return persianMap[parseInt(m)];
  });
}


export const lessThanOrEqualsTime = (leftHour, leftMin, rightHour, rightMin) => {

  if (leftHour < rightHour)
    return true;
  else if (leftHour === rightHour && leftMin <= rightMin)
    return true;

  return false;
};


export const requiredScheduleDayTimeValues = (values) => {

  if (values.fromDay !== undefined &&
    values.toDay !== undefined &&
    values.fromHour !== undefined &&
    values.toHour !== undefined &&
    values.fromMinute !== undefined &&
    values.toMinute !== undefined)
    return true;
  else
    return false;

};

export const requiredScheduleDayTimeValuesTimeOnly = (values) => {
  if (values.fromHour !== undefined && values.fromHour !== null &&
    values.toHour !== undefined && values.toHour !== null &&
    values.fromMinute !== undefined && values.fromMinute !== null &&
    values.toMinute !== undefined && values.toMinute !== null)
    return true;
  else
    return false;

};


export const lessThanTime = (leftHour, leftMin, rightHour, rightMin) => {

  if (leftHour < rightHour)
    return true;
  else if (leftHour === rightHour && leftMin < rightMin)
    return true;

  return false;
};

export const hasOverlappedDayTime = function (timeSlots) {

  if (timeSlots) {

    for (var i = 0; i < timeSlots.length - 1; i++) {
      for (var j = i + 1; j < timeSlots.length; j++) {

        if (
          timeSlots[j].fromDay <= timeSlots[i].fromDay && timeSlots[i].fromDay <= timeSlots[j].toDay
          ||
          timeSlots[i].fromDay <= timeSlots[j].fromDay && timeSlots[j].fromDay <= timeSlots[i].toDay
        ) {
          if (
            (
              lessThanOrEqualsTime(timeSlots[j].fromHour, timeSlots[j].fromMinute, timeSlots[i].fromHour, timeSlots[i].fromMinute)
              &&
              lessThanTime(timeSlots[i].fromHour, timeSlots[i].fromMinute, timeSlots[j].toHour, timeSlots[j].toMinute)
            )
            ||
            (
              lessThanOrEqualsTime(timeSlots[i].fromHour, timeSlots[i].fromMinute, timeSlots[j].fromHour, timeSlots[j].fromMinute)
              &&
              lessThanTime(timeSlots[j].fromHour, timeSlots[j].fromMinute, timeSlots[i].toHour, timeSlots[i].toMinute)
            )
          )
            return true;
        }
      }
    }
  }

  return false;
};

export const uid = () => {

  return 'uid' + Math.random().toString(36).substr(2, 16);
}

export const makeId = () => {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

export const persianToEnglishChar = (str) => {
  str = str + ''
  var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  var temp = str;
  for (var i = 0; i < 10; i++) {
    var regex_fa = new RegExp(pn[i], 'g');
    temp = temp.replace(regex_fa, en[i]);
  }
  return temp
}

export const enToPersianChar = (str) => {
  var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  var temp = str + "";
  for (var i = 0; i < 10; i++) {
    var regex_en = new RegExp(en[i], 'g');
    temp = temp.replace(regex_en, pn[i]);
  }
  return temp
}

export const showNumberNegativeToPersian = (num) => {
  if (num < 0) {
    let temp = num.toString()
    let tmp = parseInt(temp.substring(1))
    return enToPersianChar(CommaSeparator(tmp)) + '-'
  }
  else return enToPersianChar(CommaSeparator(num))
}

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result);
    }
    fileReader.onerror = (error) => {
      reject(error);
    }
  })
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export const appRouteDetection = () => {
  const isAngularJsPortal = window?.location?.href?.indexOf("/react") > -1

  return isAngularJsPortal;
}
export const CommaSeparator = (num) => {
  return num?.toLocaleString();
}

export const checkForNumericString = (str) => {
  if (str) {
    str = str.split("");
    var res = true;
    for (var i = 0; i < str.length; i++) {
      if (!str[i].match(/[0-9]/i)) {
        res = false;
      }
    }
    return res;
  }

}

export const monyFormat = (number) => (number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

function toEnglishNumber(num) {
  if (num) {
    let persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ];
    num = num.toString();
    for (var i = 0; i < 10; i++) {
      num = num.replace(persianNumbers[i], i);
    }
    return num;
  } else {
    return num;
  }
}
export function wordifyfa(input, level) {


  if (input === null) {
    return "";
  }

  let num = parseInt(toEnglishNumber(input));


  // convert negative number to positive and get wordify value
  if (num < 0) {
    num = num * -1;
    return "منفی " + wordifyfa(num, level);
  }
  if (num === 0) {
    if (level === 0) {
      return "صفر";
    } else {
      return "";
    }
  }
  let result = "";
  const yekan = ["یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"],
    dahgan = ["بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"],
    sadgan = ["یکصد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"],
    dah = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هیجده", "نوزده"];

  if (level > 0) {
    result += " و ";
    level -= 1;
  }

  if (num < 10) {
    result += yekan[num - 1];
  } else if (num < 20) {
    result += dah[num - 10];
  } else if (num < 100) {
    result += dahgan[Math.floor(num / 10) - 2] + wordifyfa(num % 10, level + 1);
  } else if (num < 1000) {
    result += sadgan[Math.floor(num / 100) - 1] + wordifyfa(num % 100, level + 1);
  } else if (num < 1000000) {
    result += wordifyfa(Math.floor(num / 1000), level) + " هزار " + wordifyfa(num % 1000, level + 1);
  } else if (num < 1000000000) {
    result += wordifyfa(Math.floor(num / 1000000), level) + " میلیون " + wordifyfa(num % 1000000, level + 1);
  } else if (num < 1000000000000) {
    result += wordifyfa(Math.floor(num / 1000000000), level) + " میلیارد " + wordifyfa(num % 1000000000, level + 1);
  } else if (num < 1000000000000000) {
    result += wordifyfa(Math.floor(num / 1000000000000), level) + " تریلیارد " + wordifyfa(num % 1000000000000, level + 1);
  }

  return result;
}

export function wordifyRials(num) {
  if (num === null || num === undefined || num === "") {
    return "";
  }
  return wordifyfa(num, 0) + " ریال";
}

export const chargeAmounts = [
  { amount: 20000, selected: false },
  { amount: 40000, selected: false },
  { amount: 60000, selected: false },
  { amount: 100000, selected: false },
  { amount: 200000, selected: false },
  { amount: 400000, selected: false }];



export const gtmDataLayerPush = function (data, type, email) {
  window.dataLayer = window.dataLayer || []

  var user = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : ''

  var objGA4 = {
    'event': 'purchase',
    'ecommerce': {
      'transaction_id': data.transactionId,
      'affiliation': data.contractType,
      'revenue': data.transactionTotal,
      'tax': data.transactionTax,
      'shipping': 0,
      "currency": "USD",
      'value': data.transactionTotal,
      'email': email ? email : user?.Email,
      "utm_term": data?.UtmInfo?.Term,
      "utm_campaign": data?.UtmInfo?.Campaign,
      "utm_medium": data?.UtmInfo?.Medium,
      "utm_source": data?.UtmInfo?.Source,
      'items': [],

    },
    'userId': user?.Id

  }
  data.transactionProducts.forEach(function (item) {

    objGA4.ecommerce.items.push({
      'name': type === 'purchase' ? item.name + "خرید" : type === 'extent' ? item.name + " تمدید" : type === 'upgrade' ? item.name + " ارتقاء" : item.name,    // Name or ID is required.

      'item_revenue': item.price,
      'index': 0,
      'item_id': item.id ? item.id : makeId(),
      "currency": "USD",
      'price': item.price,
      'item_category': item.category,
      'quantity': 1,
    })
  })

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(objGA4)
  //}

}


export const gtmConversionsPusher = function (event) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': event
  })
}


export const phoneNumberFormat = (number) => {

  if (number.length === 3)
    return number;

  if (number[0] === '0' || number[0] === '۰')
    number = '+۹۸' + number.substring(1);

  if (number.substring(0, 4) === '+989' || number.substring(0, 4) === '+۹۸۹')
    return '۰' + number.substring(3, 6) + ' ' + number.substring(6, 9) + ' ' + number.substring(9);
  else
    return '۰' + number.substring(3, 5) + ' ' + number.substring(5, 9) + ' ' + number.substring(9);
};

export const setInvoiceContent = (id, content) => {

  if (document
    .getElementById(id)) {
    document
      .getElementById(id)
      .contentWindow
      .document
      .body
      .innerHTML = content;
  }

}

export const iframeToPrint = (id) => {
  var iframeInvoice = document.getElementById(id).contentWindow;
  // focus on contentWindow is needed on some ie versions
  iframeInvoice.focus();
  iframeInvoice.print();

}

export const checkNationalCode = (code) => {
  var xv = code ? code : ''
  var res = false
  if (isNaN(xv)) {
    // alert("please enter a number !");
  } else if (xv === "") {
    // alert("please write a code !")
  } else if (xv.length < 10) {
    // alert("your entered code is less than 10!")
  } else {
    var yy = 0;
    var yv = parseInt(yy);
    for (let i = 0; i < xv.length; i++) {
      yv = xv[i] * (xv.length - i);
      yy += yv;
    }
    var x = yy % 11;
    if (x === 0) {
      res = true
    } else {
      // alert("your code is invalid !");
    }
    yy = 0;
  }
  return res;
}

export const checkNationalCode2 = (input) => {

  if (input === '')
    return true;
  if (!/^\d{10}$/.test(input))
    return false;

  var check = parseInt(input[9]);
  var sum = 0;
  var i;
  for (i = 0; i < 9; ++i) {
    sum += parseInt(input[i]) * (10 - i);
  }
  sum %= 11;

  return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
}

export const checkPostcode = (p) => {

  var pattern = /(?<!\d)\d{10}(?!\d)/;
  if (pattern.test(p) && p.length === 10) {
    return true;
  }

  return false;
}

export const getExtension = function (filename) {
  var parts = filename.split('.');
  return parts[parts.length - 1];
}


export const faxOutboxStatus = (status) => {

  switch (status) {
    case 'Sent':
      return 'ارسال شده'

    case 'Sending':

      return 'در حال ارسال'
    case 'Unsuccessful':

      return 'ناموفق'

    default:
      return 'نامشخص'
  }
}
export const DBConfig = {
  name: "DS-DB",
  version: 2,
  objectStoresMeta: [
    {
      store: "contacts",
      storeConfig: { keyPath: "contactId", autoIncrement: false },
      storeSchema: [
        { name: "name", keypath: "name", options: { unique: false } },
        { name: "familyName", keypath: "familyName", options: { unique: false } },
        { name: "age", keypath: "age", options: { unique: false } },
        { name: "isActive", keypath: "isActive", options: { unique: false } },
        { name: "defaultNumber", keypath: "defaultNumber", options: { unique: false } },
        { name: "phoneBookId", keypath: "phoneBookId", options: { unique: false } },
        { name: "number1", keypath: "number1", options: { unique: false } },
        { name: "number2", keypath: "number2", options: { unique: false } },
        { name: "number3", keypath: "number3", options: { unique: false } },
        { name: "number4", keypath: "number4", options: { unique: false } },
      ],
    },

  ],
};

export const useContactStore = () => {
  return useIndexedDB("contacts", DBConfig);
}

export const getEnDateFromPersianDate = (date) => {
  return moment(date, "jYYYY/jMM/jDD").locale('en').format('YYYY-MM-DD')
}

export const getDateOfTimeZoneDate = (date) => {
  if (date) {
    return date.split('T')[0]
  }
  return (date)
}

export const getPersianDateFromPEnDate = (date) => {
  return moment(getDateOfTimeZoneDate(date), "YYYY-MM-DD").locale('fa').format("jYYYY/jMM/jDD")
}



export const createCalendar = (year, holidays, otherSelectionDays, selectedDates, overlapDates) => {
  const faDayWeek = {

    '0': 'یکشنبه', '1': 'دوشنبه', '2': 'سه‌شنبه', '3': 'چهارشنبه', '4': 'پنج‌شنبه', '5': 'جمعه', '6': 'شنبه',
  }

  const faMonth = {

    1: 'فروردین', 2: 'اردیبهشت', 3: 'خرداد', 4: 'تیر', 5: 'مرداد', 6: 'شهریور',
    7: 'مهر', 8: 'آبان', 9: 'آذر', 10: 'دی', 11: 'بهمن', 12: 'اسفند',
  }
  let months = []
  let fridays = []
  if (moment) {
    for (let i = 0; i < 12; i++) {
      let dayCount = moment.jDaysInMonth(year, i)
      let temp = { month: faMonth[i + 1], days: [] }
      for (let j = 0; j < dayCount; j++) {
        let m = moment().jYear(year).jMonth(i).jDate(j + 1)
        const dateStr = m.format("jYYYY/jMM/jDD")
        const enDateStr = getEnDateFromPersianDate(dateStr)
        const dayNumber = parseInt(m.locale('fa').format('d'))
        if (j === 0 && dayNumber !== 6) {
          for (let i = 0; i < dayNumber + 1; i++) {
            temp.days.unshift({
              name: "",
              dateStr: "",
              dayNumber: 0,
              day: '',
              jalaliName: "",
              isWeeklyHoliday: false,
              isAnnualHoliday: false,
              annualHolidayReason: "",

            })

          }
        }
        let tempModel = {
          name: faDayWeek[m.locale('fa').format('d')],
          dateStr: dateStr,
          dayNumber: dayNumber,
          day: j + 1,
          jalaliName: "",
          isWeeklyHoliday: false,
          isAnnualHoliday: false,
          annualHolidayReason: "",
          enStr: getEnDateFromPersianDate(dateStr),
          classList: [],
          title: ""
        }
        const holiday = holidays?.find(holiday => getDateOfTimeZoneDate(holiday.date) === enDateStr)

        if (holiday) {

          tempModel.classList.push('holiday')
          tempModel.title = dayNumber !== 5 ? holiday.title : holiday.title + ' جمعه'
          tempModel.isPersianHoliday = true
        } else if (dayNumber === 5) {
          tempModel.classList.push('holiday')
          tempModel.title = 'جمعه'
        }
        if (otherSelectionDays?.some((i) => i === enDateStr)) {
          tempModel.classList.push('other-day-selected')
        }
        if (selectedDates?.some((i) => i === enDateStr)) {
          tempModel.classList.push('selected-by-cel')

        }
        selectedDates?.forEach((date, idx) => {
          if (date === enDateStr && overlapDates?.some((i) => i.dateIdx === idx)) {
            if (!tempModel.classList.some(c => c === 'overlap-date')) {
              tempModel.classList.push('overlap-date')
              tempModel.title += " " + overlapDates.find((i) => i.dateIdx === idx)?.errorText
            }

          }
        })

        if (tempModel.dayNumber === 5) {
          fridays.push(tempModel)
        }
        temp.days.push(tempModel)

      }
      months.push(temp)
    }
    // for (let j = 0; j < months.length; j++) {
    //   const dayNumber = months[j].days[0].dayNumber != 6 ? months[j].days[0].dayNumber + 1 : 0
    //   for (let i = 0; i < dayNumber; i++) {
    //     months[j].days.unshift({
    //       name: "",
    //       dateStr: "",
    //       dayNumber: 0,
    //       day: '',
    //       jalaliName: "",
    //       isWeeklyHoliday: false,
    //       isAnnualHoliday: false,
    //       annualHolidayReason: "",
    //     })

    //   }

    // }
  }

  return { months, fridays }

}

export const annualHoliday1402 = [{ date: "1402/01/01", description: "" },
{ date: "1402/01/02", description: "" }, { date: "1402/01/03", description: "" }, { date: "1402/01/04", description: "" },
{ date: "1402/01/12", description: "" }, { date: "1402/01/13", description: "" },
{ date: "1402/02/03", description: "" },
{ date: "1402/02/12", description: "" }, { date: "1402/02/13", description: "" }, { date: "1402/03/05", description: "" },
{ date: "1402/03/14", description: "" }, { date: "1402/03/15", description: "" }, { date: "1402/04/19", description: "" },
{ date: "1402/04/27", description: "" },
{ date: "1402/05/16", description: "" },
{ date: "1402/05/17", description: "" }, { date: "1402/06/26", description: "" }, { date: "1402/07/03", description: "" },
{ date: "1402/07/05", description: "" }, { date: "1402/07/13", description: "" }, { date: "1402/07/22", description: "" },
{ date: "1402/10/06", description: "" },
{ date: "1402/11/15", description: "" },
{ date: "1402/11/22", description: "" }, { date: "1402/12/17", description: "" }, { date: "1402/12/29", description: "" }]

export const tableHead = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ',
  'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی']
export const numberPreparationInContact = (number) => {
  if (number === '' || number === null) {
    return undefined
  }
  if (number?.startsWith('98')) {
    return '+' + number;
  }

  return '+98' + number
}

export const SanitizeInput = (value) => {
  if (value === null || value === undefined || value === "") return value
  else {
    const config = {
      ALLOWED_TAGS: [],
    };
    return DOMPurify.sanitize(value, config)

  }

}

export const useOutsideAlerter = (ref, setDisplay) => {
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setDisplay(false)
      }
    }
    document.body.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.body.removeEventListener('mousedown', handleClickOutside)

    }
  }, [ref])
}

export const getDateYear = (date) => {
  return moment(date, 'YYYY-MM-DD').locale('fa').format('jYYYY')
}

export const removeDuplicates = (list) => {
  return list.filter((property, idx) => list.indexOf(property) === idx)
}

export const getCurrentDateFormat = (format) => {
  return moment().format(format)
}

export const wizardStepDetection = (step, isFree) => {
  switch (step) {
    case 'step-1':
      return { text: "مرحله ۱: اطلاعات کاربری", number: 1 }
    case 'step-2':
      return { text: "مرحله ۲: انتخاب شماره", number: 2 }
    case 'step-3':
      return { text: "مرحله ۳: توافق‌نامه خدمات", number: 3 }
    case 'step-4':
      return { text: isFree ? "مرحله ۴: فعالسازی" : "مرحله ۴: صورت حساب", number: 4 }
    case 'step-5':
      return { text: "مرحله ۵: فعالسازی", number: 5 }

    default:
      return { text: "", number: 0 }
  }
}

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const isValidEmailStrictly = (email) => {
  if (!email.trim())
    return false;
  var persianOrASCII = /[آ-ی]/;

  if (email.trim().match(persianOrASCII)) {
    return false;
  }

  var mainDomainStartIndex = email.trim().lastIndexOf('.');

  if (mainDomainStartIndex === -1)
    return false;

  var mainDomain = email.trim().slice((email.trim().length - mainDomainStartIndex - 1) * -1).toLowerCase();
  var validMainDomains = ['com', 'org', 'info', 'ir', 'net', 'cm', 'biz', 'ru', 'ac', 'co', 'de', 'in', 'ml', 'om', 'us', 'uk', 'tv', 'pro', 'edu', 'ca', 'io'];

  if (validMainDomains.every(function (value) { return value !== mainDomain })) {
    return false;
  }
  if (email.trim().split('@').length > 2) {
    return false;
  }

  return true;
}


export const timingFunction = (setIsInProgressing, isInProgressing, callBackfunction) => {

  window.clearTimeout(isInProgressing);
  const _isInProgressing = setTimeout(function () {

    callBackfunction()

  }, 1000);
  setIsInProgressing(_isInProgressing)

}

export const setToken = (token) => {
  document.cookie = "token=" + JSON.stringify(token) + ";path=/";

  // document.cookie = "token=" + JSON.stringify(token) + ";path=/;domain=http://portalold.daftareshoma.com;Secure; SameSite=None";
  // document.cookie = "token=" + JSON.stringify(token) + ";path=/;domain=.daftareshoma.com;Secure; SameSite=None";

  Cookies.set('token', JSON.stringify(token), {
    domain: 'daftareshoma.com',
    path: '/',
    secure: false,
    sameSite: 'None'
  });

}

export const customTrim = (email) => {
  if (email) {
    return email.replace(/\s+/g, '')
  }
  return ""
}
export const handleSendToOldVersion = (route) => {
  const params = {
    route: route,
    token: localStorage.getItem('token'),
  };
  const queryString = Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  debugger
  window.open(`${process.env.REACT_APP_OLD_VERSION_BASE_URL}/login.html?${queryString}`, '_blank')
}

export const createDownloadLink = (link) => {

  const _link = document.createElement('a');


  if (link === "/InstructionFiles/Rahnama-Gooya.pdf") {
    _link.href = '/Rahnama-Gooya-V3.1.pdf';
    _link.download = 'Rahnama-Gooya-V3.1.pdf';
    document.body.appendChild(_link);
    _link.click();
    document.body.removeChild(_link);
    return false;
  } else if (link === "/InstructionFiles/Rahnama-Monshi.pdf") {

    _link.href = '/Rahnama-monshi-(V2.0).pdf';
    _link.download = 'Rahnama-monshi-(V2.0).pdf';
    document.body.appendChild(_link);
    _link.click();
    document.body.removeChild(_link);
    return false
  } else {
    return true;
  }

}

